import { useEffect } from 'react';
import {
    Layout,
    Menu,
    Card,
    Typography,
    Button,
    theme,
} from 'antd';
import {
    TeamOutlined,
    BarChartOutlined,
    ArrowLeftOutlined,
    MessageOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { useThemeStore } from 'shared-lib';
import { useNavigate, useLocation } from 'react-router-dom';
import TenantManagement from './components/TenantManagement';
import BillingStatistics from './components/BillingStatistics';
import AppFeedbackOverview from './components/AppFeedbackOverview';
import { useTenantStore } from '../../state/tenant_state';

const { Content, Sider } = Layout;
const { Title } = Typography;

const menuItems: MenuProps['items'] = [
    {
        key: 'tenants',
        icon: <TeamOutlined />,
        label: 'Mandanten Verwaltung',
    },
    {
        key: 'billing',
        icon: <BarChartOutlined />,
        label: 'Abrechnungsstatistik',
    },
    {
        key: 'feedback',
        icon: <MessageOutlined />,
        label: 'Feedback',
    },
];

export default function AdminPage() {
    const { token } = theme.useToken();
    const themeState = useThemeStore();
    const navigate = useNavigate();
    const location = useLocation();
    const tenantStore = useTenantStore();

    // Extract current section from URL
    const pathSegments = location.pathname.split('/');
    const currentSection = pathSegments[2] || 'dashboard'; // /admin/[section]

    const handleMenuClick: MenuProps['onClick'] = (e) => {
        navigate(`/admin/${e.key}`);
    };

    const handleBackToTenantSelection = () => {
        tenantStore.clearTenantData();
        navigate('/');
    };

    // Handle default route redirect
    useEffect(() => {
        if (location.pathname === '/admin' || location.pathname === '/admin/') {
            navigate('/admin/tenants', { replace: true });
        }
    }, [location.pathname, navigate]);

    const renderContent = () => {
        switch (currentSection) {
            case 'tenants':
                return <TenantManagement />;
            case 'billing':
                return <BillingStatistics />;
            case 'feedback':
                return <AppFeedbackOverview />;
            default:
                return <TenantManagement />;
        }
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Sider
                width={250}
                style={{
                    overflow: 'auto',
                    height: '100vh',
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    bottom: 0,
                }}
                theme={themeState.theme}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        paddingTop: 15,
                        height: '100%',
                        paddingBottom: 15,
                    }}
                >
                    <div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                marginBottom: 20,
                                flex: 0,
                            }}
                        >
                            <img src="/assets/logo_full.png" width={150} />
                        </div>

                        <Card
                            size="small"
                            style={{
                                margin: '0 15px 20px 15px',
                                textAlign: 'center',
                                backgroundColor: token.colorPrimaryBg,
                                border: `1px solid ${token.colorPrimaryBorder}`,
                            }}
                        >
                            <Title level={5} style={{ margin: 0, color: token.colorLink }}>
                                Admin Interface
                            </Title>
                        </Card>

                        <Menu
                            theme={themeState.theme}
                            mode="vertical"
                            selectedKeys={[currentSection]}
                            items={menuItems}
                            onClick={handleMenuClick}
                        />
                    </div>
                    <div>
                        <Button
                            type="text"
                            icon={<ArrowLeftOutlined />}
                            onClick={handleBackToTenantSelection}
                            style={{
                                margin: '0px 15px',
                                width: 'calc(100% - 30px)',
                            }}
                        >
                            Zurück
                        </Button>
                    </div>
                </div>
            </Sider>
            <Content
                style={{
                    marginLeft: 64,
                    padding: 0,
                    overflow: 'initial',
                    //minHeight: '100vh',
                }}
            >
                {renderContent()}
            </Content>
        </Layout>
    );
}